import { Client } from '@/manager/client/client.model';
import Provider from '@/manager/business/models/provider.model';
import BillLine from '@/manager/billing/models/bill-line.model';
import { PaymentMethod } from '@/clickbuy/purchase/models/purchase.model';

export enum TransactionType {
    TransactionEmitted = 1,
    TransactionReceived = 2,
}
export enum TransactionTypeLiterals {
    '',
    'Emitida',
    'Recibida',
}
export interface BillTotalPricing {
    totalPrice?: number;
    totalPriceTax?: number;
    totalPriceWithoutTax?: number;
    totalAmount?: number;
}
export interface BillClientInfo {
    name?: string;
    email?: string;
    nif?: string;
    phone?: string;
    address?: string;
    postalCode?: string;
    town?: string;
    state?: string;
}
export interface BillInterface {
    publicId?: string;
    displayId?: string;
    internalBusiness?: string;
    client?: Client;
    provider?: Provider;
    date?: string;
    transactionType?: TransactionType;
    numberOfNotes?: number;
    billLine?: BillLine[];
    paymentMethod?: PaymentMethod;
    refundedBill?: string;
}

export default class Bill implements BillInterface, BillTotalPricing, BillClientInfo {
    public id?: string;
    public publicId?: string;
    public displayId?: string;
    public internalBusiness?: string;
    public client?: Client;
    public provider?: Provider;
    public date?: string;
    public transactionType?: TransactionType;
    public numberOfNotes?: number;
    public name?: string;
    public email?: string;
    public nif?: string;
    public phone?: string;
    public address?: string;
    public postalCode?: string;
    public town?: string;
    public state?: string;
    public totalPrice?: number;
    public totalPriceTax?: number;
    public totalPriceWithoutTax?: number;
    public totalAmount?: number;
    public billLine?: BillLine[];
    public paymentMethod?: PaymentMethod;
    public refundedBill?: string;
    public changeDataRefundedBill?: string;
    public cardLastDigits?: number;
    public fiscalData?: number;
    public fiscalDataExtension?: number;


    constructor() {
        this.client = new Client();
        this.provider = new Provider();
        const newLine = new BillLine();
        this.billLine = [newLine];
        this.transactionType = TransactionType.TransactionEmitted;
        this.paymentMethod = PaymentMethod.Cash;
    }
}
